import { map, reverse, append, getSlice, tryFindIndex, head, cons, tryHead, length, empty, singleton } from "../fable_modules/fable-library.4.1.4/List.js";
import { class_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { some } from "../fable_modules/fable-library.4.1.4/Option.js";

export class CQRS$2 {
    constructor(initialState, execute) {
        this.execute = execute;
        this.state = initialState;
        this.stateHistoryRev = singleton([0, [void 0, this.state]]);
        this.stateFuturesRev = empty();
        const currentMarker = length(this.stateHistoryRev) | 0;
    }
}

export function CQRS$2_$reflection(gen0, gen1) {
    return class_type("CQRS.CQRS`2", [gen0, gen1], CQRS$2);
}

export function CQRS$2_$ctor_Z5C8122BF(initialState, execute) {
    return new CQRS$2(initialState, execute);
}

export function CQRS$2__get_State(_) {
    return _.state;
}

export function CQRS$2__Execute_2B595(this$, msg) {
    const state$0027 = this$.execute(msg, this$.state);
    this$.state = state$0027;
    let marker;
    const _arg = tryHead(this$.stateHistoryRev);
    marker = ((_arg == null) ? 0 : (_arg[0] + 1));
    this$.stateHistoryRev = cons([marker, [some(msg), state$0027]], this$.stateHistoryRev);
    this$.stateFuturesRev = empty();
}

export function CQRS$2__Checkpoint(_) {
    return head(_.stateHistoryRev)[0];
}

export function CQRS$2__Rewind_Z524259A4(this$, mark) {
    const matchValue = tryFindIndex((tupledArg) => (tupledArg[0] === mark), this$.stateHistoryRev);
    if (matchValue == null) {
        throw new Error(`Invalid marker: ${mark}`);
    }
    else {
        const ix = matchValue | 0;
        const removal = getSlice(void 0, ix - 1, this$.stateHistoryRev);
        this$.stateHistoryRev = getSlice(ix, void 0, this$.stateHistoryRev);
        this$.stateFuturesRev = append(removal, this$.stateFuturesRev);
        this$.state = head(this$.stateHistoryRev)[1][1];
    }
}

export function CQRS$2__FastForward_Z524259A4(this$, mark) {
    const matchValue = tryFindIndex((tupledArg) => (tupledArg[0] === mark), this$.stateFuturesRev);
    if (matchValue == null) {
        throw new Error(`Invalid marker: ${mark}`);
    }
    else {
        const ix = matchValue | 0;
        const removal = getSlice(void 0, ix - 1, this$.stateFuturesRev);
        this$.stateFuturesRev = getSlice(ix, void 0, this$.stateFuturesRev);
        this$.stateHistoryRev = append(removal, this$.stateHistoryRev);
        this$.state = head(this$.stateFuturesRev)[1][1];
    }
}

export function CQRS$2__Log(this$) {
    return reverse(map((arg) => arg[1][1], this$.stateHistoryRev));
}

export function CQRS$2__LogWithMessages(this$) {
    return map((tuple) => tuple[1], reverse(this$.stateHistoryRev));
}

export function CQRS$2_Create_Z5C8122BF(st, f) {
    return CQRS$2_$ctor_Z5C8122BF(st, f);
}

//# sourceMappingURL=CQRS.fs.js.map
